<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import AdvantageForm from "@/views/pages/collaborators/forms/advantage/advantage-form.vue";
import CustomTable from "@/components/tables/custom-table.vue";
import AddButton from "@/components/buttons/add-button.vue";
import Status from "@/helpers/general/status";
import CollaboratorShow from "@/views/pages/collaborators/show/show.vue";
import FeaturedIcon from '@/components/widgets/featured-icon.vue';
import OnlineIcon from '@/components/widgets/online-icon.vue';
import CopyClipboard from "@/components/widgets/copy-clipboard.vue";
import SelectAutocompleteField from "@/components/forms/select-autocomplete-field.vue";
import SelectField from "@/components/forms/select-field.vue";
import EycaSyncBtn from '@/components/widgets/eyca-sync-btn.vue';

/**
 * Advantages Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        CustomTable,
        AdvantageForm,
        AddButton,
        CollaboratorShow,
        FeaturedIcon,
        OnlineIcon,
        CopyClipboard,
        SelectAutocompleteField,
        SelectField,
        EycaSyncBtn
    },
    data() {
        return {
            showModalId: 'advantage-show-modal',
            showCollaboratorModalId: 'advantage-collaborator-show-modal',
            formModalId: 'advantage-form-modal',
            pageHeader: {
                title: "Ventajas",
                breadcrumbs: [
                    {
                        text: "Ventajas",
                        href: "/advantages",
                        active: true
                    }
                ],
            },
            advantage_status: [...Status.getList('advantage_status'), { id: 'all', label: 'Todos', class: 'badge badge-soft-secondary font-size-11' }],
            yes_not: Status.getList('yes_not'),
            advantage_types: Status.getList('advantage_types'),
            eyca_sync_status: Status.getList('eyca_sync_status'),
            table: {
                url: '/advantages',
                params: {
                    'with_trashed': 1,
                },
                fields: [
                    { key: "id", label: "Cod", sortable: true },
                    { key: "created_at", label: "Fecha de creación", sortable: true },
                    { key: "name", label: "Nombre", sortable: true },
                    { key: "description", label: "Descripción", sortable: true },
                    { key: "collaborator.business_name", label: "Colaborador", sortable: false },
                    { key: "creator.name", label: "Creado por", sortable: false },
                    { key: "approver.name", label: "Aprobado por", sortable: false },
                    { key: "product_category.name", label: "Categoría", sortable: false },
                    { key: "status", label: "Estado", sortable: false },
                    { key: "featured", label: "Destacada", sortable: false },
                    { key: "online", label: "Online", sortable: false },
                ],
                formatted_fields: [
                    'created_at',
                    'status',
                    'featured',
                    'online',
                    'description',
                    'collaborator.business_name',
                ]
            },
            filters: {
                search: null,
                collaborator_id: null,
                status: 'all',
                featured: null,
                advantage_type: null,
                product_category_id: null,
                product_category_parent_id: null,
                population_id: null,
                tag: null,
                eyca_sync_status: null
            },
            formSelectedItemId: null,
            formSelectedCollaboratorItem: null,
            showSelectedItemId: null,
            showSelectedCollaboratorItem: null,
        };
    },
    methods: {
        showViewModal(item) {
            this.showSelectedItemId = item?.id || null;
            this.$bvModal.show(this.showModalId);
        },
        showFormModal(item) {
            this.formSelectedItemId = item?.id || null;
            this.formSelectedCollaboratorItem = item?.collaborator || null;
            this.$bvModal.show(this.formModalId);
        },
        showViewCollaboratorModal(item) {
            this.showSelectedCollaboratorItem = item?.collaborator_id || null;
            this.$bvModal.show(this.showCollaboratorModalId);
        },
        onSuccess() {
            this.$refs.advantageTable.refresh();
        },
        formatter(field, item) {
            switch (field) {
                case 'status':
                    return Status.getStatus({ itemStatus: item?.status, type: 'advantage_status', html: true });
                default:
                    return '';
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <CollaboratorShow :modal-id="showCollaboratorModalId" :id="showSelectedCollaboratorItem" :default-active-tab="2"></CollaboratorShow>
                        <AdvantageForm :modal-id="formModalId" :collaborator="formSelectedCollaboratorItem" :id="formSelectedItemId" @onSuccess="onSuccess"></AdvantageForm>
                        <CustomTable
                            :url="table.url"
                            :fields="table.fields"
                            :formatted-fields="table.formatted_fields"
                            :formatter="formatter"
                            :params="table.params"
                            ref="advantageTable"
                            :show-view="false"
                            :show-edit="true"
                            :showSoftDelete="false"
                            @show="showViewModal"
                            @edit="showFormModal"
                            :show-modal-id="showModalId"
                            :filters2="filters"
                        >
                            <template v-slot:header-actions>
                                <AddButton @click="showFormModal"></AddButton>
                            </template>
                            <template v-slot:filters="{ filters }">
                                <div class="row">
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label for="search">Buscar</label>
                                        <input id="search" v-model="filters.search" type="text" class="form-control"
                                            placeholder="Buscar..." />
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Colaborador</label>
                                        <SelectAutocompleteField
                                            :url="`/collaborators`"
                                            :only-ids="true"
                                            :multiple="false"
                                            :placeholder="'Busca un colaborador'"
                                            :label="'business_name'"
                                            v-model="filters.collaborator_id"
                                        ></SelectAutocompleteField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label for="status">Estado</label>
                                        <SelectField 
                                            label="label" 
                                            placeholder="Selecciona un estado" 
                                            :multiple="false"
                                            :options="advantage_status" 
                                            v-model="filters.status"
                                        ></SelectField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Destacada</label>
                                        <SelectField 
                                            label="label" 
                                            placeholder="Todos" 
                                            :multiple="false"
                                            :options="yes_not" 
                                            v-model="filters.featured"
                                        ></SelectField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Tipo de ventaja</label>
                                        <SelectField 
                                            label="label" 
                                            placeholder="Todos" 
                                            :multiple="false"
                                            :options="advantage_types" 
                                            v-model="filters.advantage_type"
                                        ></SelectField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Categoría</label>
                                        <SelectAutocompleteField
                                            :url="`/product-categories`"
                                            :only-ids="true"
                                            :multiple="false"
                                            :placeholder="'Busca una categoría'"
                                            :label="'name'"
                                            v-model="filters.product_category_id"
                                        ></SelectAutocompleteField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Población</label>
                                        <SelectAutocompleteField
                                            :url="`/populations`"
                                            :only-ids="true"
                                            :multiple="false"
                                            :placeholder="'Busca una población'"
                                            :label="'fullname'"
                                            v-model="filters.population_id"
                                        ></SelectAutocompleteField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Etiquetas</label>
                                        <SelectAutocompleteField
                                            :url="`/tags`"
                                            :only-ids="true"
                                            :multiple="true"
                                            :placeholder="'Busca una etiqueta'"
                                            :label="'name'"
                                            :field="'name'"
                                            v-model="filters.tag"
                                        ></SelectAutocompleteField>
                                    </div>
                                    <div class="form-group col-12 col-lg-3 col-sm-6">
                                        <label>Sincronización con Eyca</label>
                                        <SelectField label="label" placeholder="Todos"
                                            :options="eyca_sync_status" v-model="filters.eyca_sync_status"></SelectField>
                                    </div>
                                </div>
                            </template>
                            <template #cell-description="{ item }">
                                <CopyClipboard :text="item?.description" class="mr-2"></CopyClipboard>
                                <span :title="item?.description">{{ item?.description | truncateText(50) }}</span>
                            </template>
                            <template #cell-featured="{ item }">
                                <featured-icon :featured="item?.featured"></featured-icon>
                            </template>
                            <template #cell-online="{ item }">
                                <online-icon :online="item?.online"></online-icon>
                            </template>
                            <template #cell-created_at="{ item }">
                                <span v-format-date="item?.created_at"></span>
                            </template>
                            <template v-slot:cell-collaborator.business_name="{ item }">
                                <a href="javascript:void(0);" class="mr-1 text-primary" v-b-tooltip.hover title="Ver colaborador"
                                    v-if="item?.collaborator_id" @click="showViewCollaboratorModal(item)">
                                    <i class="ri-eye-fill font-size-18"></i>
                                </a>
                                <span>{{ item?.collaborator?.business_name }}</span>
                            </template>
                            <template v-slot:before-custom-actions="slotProps">
                                <EycaSyncBtn :advantage="slotProps.row?.item" @onSuccess="onSuccess" @onError="onSuccess"></EycaSyncBtn>
                            </template>
                        </CustomTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template> 